<template>
  <div>
    <el-form
      ref="editForm"
      class="table-class demo-form-inline"
      :model="editForm"
      :rules="rules"
    >
      <el-row v-show="false" :gutter="80">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="工单编号" prop="workOrderNo">
            <el-input
              v-model="editForm.workOrderNo"
              :disabled="!isAdd"
              placeholder=""
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="80">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="报销总金额" prop="amount">
            <el-input
              v-model="editForm.amount"
              :disabled="true"
              placeholder=""
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="80">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item>
            <costadd
              v-show="isShowAmountAnnex"
              ref="photobx"
              :is-show-file-name="false"
              :type="'50'"
              :is-edit="false"
              :row="object"
            ></costadd>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="80">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="快递公司" prop="courierCompany">
            <el-input
              v-model="editForm.courierCompany"
              :disabled="true"
              placeholder=""
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="80">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="快递单号" prop="courierNumber">
            <el-input
              v-model="editForm.courierNumber"
              :disabled="true"
              placeholder=""
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="80">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item>
            <costadd
              v-show="isShowNumberAnnex"
              ref="photodh"
              :is-show-file-name="false"
              :is-edit="false"
              :type="'50'"
              :row="object"
            ></costadd>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { isExistOSS } from "@/utils/index";
  // 拍摄照片
  import costadd from "@/views/workplace/components/costAdd";
  import {
    add,
    update,
    getInfo,
    delInfo,
  } from "@/api/workplace/investigate/statistical";
  import { getRoleKey, eighthBitTime, downloadFile } from "@/utils/index";
  import { isNum } from "@/utils/validate";

  export default {
    name: "Edit",
    components: {
      costadd,
    },
    data() {
      const validateNum = (rule, value, callback) => {
        if (!isNum(value)) {
          callback(new Error("请输入数字，允许带两位小数"));
        } else {
          callback();
        }
      };
      return {
        isShowAmountAnnex: true,
        isShowNumberAnnex: true,
        isAdd: true,
        saveLoading: false,
        annexGroup: [],
        title: "",
        editFormVisible: false,
        object: {},
        //编辑给后端的接口参数
        editForm: {
          amount: null,
          courierCompany: null,
          courierNumber: null,
          courierAmountAnnex: [],
          courierNumberAnnex: [],
          delCourierAmountAnnex: [],
          delCourierNumberAnnex: [],
          workOrderNo: null,
        },
        // 获取工单详情
        editParam: {
          body: {
            userNo: "",
            userRoleNo: "",
            workOrderNo: null,
            seqId: null,
          },
          header: {
            currentTime: "2020-09-09 12:12:12",
            requestId: "1",
            sourceType: "site",
          },
        },
        rules: {
          workOrderNo: [
            {
              required: true,
              trigger: "blur",
              message: "请输入工单编号！",
            },
          ],
        },
      };
    },
    computed: {
      ...mapGetters({
        userNo: "user/userNo",
        roles: "user/roles",
        endpoinxBak: "user/endpoinxBak",
        OSSClient: "user/OSSClient",
      }),
    },
    created() {
      this.editParam.body.userNo = this.userNo;
      this.editParam.body.userRoleNo = getRoleKey("supervisor", this.roles);
    },
    methods: {
      async showEdit(row, isAdd) {
        this.isAdd = isAdd;
        this.title = isAdd ? "添加统计" : "统计编辑";
        this.object = row;
        this.editForm.workOrderNo =
          row.workOrderNo === undefined ? "" : row.workOrderNo;
        this.editParam.body.seqId = this.object.seqId;
        //更新当前页面数据
        if (!this.isAdd) {
          const { body, header } = await getInfo({
            body: {
              seqId: this.object.seqId,
              userNo: this.editParam.body.userNo,
              userRoleNo: this.editParam.body.userRoleNo,
              workOrderNo: this.object.workOrderNo,
            },
            header: {
              currentTime: "2020-09-09 12:12:12",
              requestId: "1",
              sourceType: "site",
            },
          });
          this.editFormVisible = true;
          this.$nextTick(() => {
            this.$refs["editForm"].resetFields();
            this.$refs["photobx"].checkAll = false;
            this.$refs["photodh"].checkAll = false;
            this.$refs["photodh"].imgRecordData = [];
            this.$refs["photobx"].imgRecordData = [];
            this.$refs["photodh"].deleteRecordData = [];
            this.$refs["photodh"].addRecordData = [];
            this.$refs["photobx"].deleteRecordData = [];
            this.$refs["photobx"].addRecordData = [];
            this.bindData(body);
          });
        } else {
          this.editFormVisible = true;
          this.$nextTick(() => {
            this.editForm.workOrderNo = "";
            this.$refs["editForm"].resetFields();
            this.$refs["photobx"].checkAll = false;
            this.$refs["photodh"].checkAll = false;
            this.$refs["photodh"].imgRecordData = [];
            this.$refs["photobx"].imgRecordData = [];
            this.$refs["photodh"].deleteRecordData = [];
            this.$refs["photodh"].addRecordData = [];
            this.$refs["photobx"].deleteRecordData = [];
            this.$refs["photobx"].addRecordData = [];
          });
        }
      },
      bindData(body) {
        this.editForm.workOrderNo = this.object.workOrderNo;
        this.editParam.body.seqId = this.object.seqId;
        this.editForm.amount = body.amount;
        this.editForm.courierCompany = body.courierCompany;
        this.editForm.courierNumber = body.courierNumber;
        if (
          body.courierCompanyAnnex !== undefined &&
          null !== body.courierCompanyAnnex
        ) {
          this.editForm.courierAmountAnnex = body.courierCompanyAnnex;
          this.$refs["photobx"].imgRecordData =
            this.editForm.courierAmountAnnex == null
              ? []
              : this.editForm.courierAmountAnnex.map((x, index) => {
                  return {
                    name: "",
                    path: x.annexAddress,
                    seqId: x.seqId, // 常量保证查看的数据不计算在增量文件内
                    sortNumber: index,
                    mychecked: false,
                  };
                });
        } else {
          this.isShowAmountAnnex = false;
        }

        if (
          body.courierNumberAnnex !== undefined &&
          null !== body.courierNumberAnnex
        ) {
          this.editForm.courierNumberAnnex = body.courierNumberAnnex;
          this.$refs["photodh"].imgRecordData =
            this.editForm.courierNumberAnnex == null
              ? []
              : this.editForm.courierNumberAnnex.map((x, index) => {
                  return {
                    name: "",
                    path: x.annexAddress,
                    seqId: x.seqId,
                    sortNumber: index,
                    mychecked: false,
                  };
                });
        } else {
          this.isShowNumberAnnex = false;
        }
      },
      close() {
        this.editFormVisible = false;
      },
      save() {
        this.$refs["editForm"].validate(async (valid) => {
          if (valid) {
            this.editForm.courierAmountAnnex = this.$refs[
              "photobx"
            ].addRecordData;
            this.editForm.delCourierAmountAnnex = this.$refs[
              "photobx"
            ].deleteRecordData;
            this.editForm.courierNumberAnnex = this.$refs[
              "photodh"
            ].addRecordData;
            this.editForm.delCourierNumberAnnex = this.$refs[
              "photodh"
            ].deleteRecordData;
            this.editParam.body = Object.assign(
              this.editParam.body,
              this.editForm
            );
            // 操作记录
            const { header } = this.isAdd
              ? await add(this.editParam)
              : await update(this.editParam);
            if ("1" === header.retCode) {
              this.$emit("refreshData");
              this.$baseMessage(header.retMessage, "success");
              this.editFormVisible = false;
            } else {
              this.$baseMessage(header.retMessage, "error");
            }
            this.saveLoading = false;
          } else {
            return false;
          }
        });
      },
      del() {
        this.$confirm("确认要删除吗")
          .then((_) => {
            delInfo({
              body: {
                seqId: this.object.seqId,
                userNo: this.editParam.body.userNo,
                userRoleNo: this.editParam.body.userRoleNo,
                workOrderNo: this.object.workOrderNo,
              },
              header: {
                currentTime: "2020-09-09 12:12:12",
                requestId: "1",
                sourceType: "site",
              },
            }).then((res) => {
              if (res.header.retCode === "1") {
                this.$baseMessage(res.header.retMessage, "success");
                this.editFormVisible = false;
                this.$emit("refreshData");
              } else {
                this.$message.error(`${res.header.retMessage}`);
              }
              this.saveLoading = false;
            });
          })
          .catch((_) => {});
      },
      eighthBitTime(row, column) {
        return eighthBitTime(row, column);
      },
      /** 当前dialog关闭 */
      handleClose() {
        this.fullFlag = false;
        this.fullIcon = "el-icon-full-screen";
        this.fullTitle = "最大化";
        this.editFormVisible = false;
      },
    },
  };
</script>

<style>
  body {
    font-weight: 700;
    color: #666;
  }
  .edit_title .title {
    margin: 10px 0;
  }
  .el-step__title {
    font-size: 14px;
  }
  .el-step__title.is-process {
    font-weight: bold;
    color: #666;
  }
  html body .el-table th .cell {
    font-weight: 700;
    color: #666;
  }

  .el-form-item__label {
    font-weight: normal;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner,
  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 100% !important;
  }

  .el-select,
  .el-cascader {
    width: 100%;
  }
  .my-textarea > textarea {
    height: 32px;
  }
</style>
